// Full text stays visible (dyslexia-friendly); the spoken line lights up.
export const Teleprompter = ({ lines, lineIdx, phase }) => {
  const live = phase === "playing" || phase === "paused";
  return (
    <div className="flex-1 max-w-3xl mx-auto w-full space-y-5 mb-12" data-testid="cinematic-teleprompter">
      {lines.map((ln, i) => {
        const active = i === lineIdx && live;
        let tone = "text-lg md:text-xl text-[#A8A29E]";
        if (active) tone = "text-2xl md:text-4xl text-[#1C1917]";
        else if (lineIdx > i) tone = "text-lg md:text-xl text-[#A8A29E]";
        return (
          <p
            key={ln.slice(0, 24)}
            data-testid={active ? "cinematic-line-current" : undefined}
            className={`font-display tracking-tight leading-snug transition-all duration-500 text-center ${tone}`}
          >
            {ln}
          </p>
        );
      })}
    </div>
  );
};
